module.exports = __webpack_public_path__ + "img/smartsupp.b25fa167.png";